import React from "react";
import { Banner, Icon, SheetContainer, Text } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import useToggle from "../../../hooks/useToggle.js";
import useUserAgent from "../../../hooks/useUserAgent.js";
import Frame from "../Frame/index.js";
import { t, useI18n } from "@bookingcom/lingojs-react";
const SearchResultBanner = ({ banner }) => {
    const { visible: showPopover, show: showModal, hide: hideModal } = useToggle();
    const { isMobile } = useUserAgent();
    const i18n = useI18n();
    if (!banner) {
        return null;
    }
    const { dismissible, type, title, media, message, actionLabel, details } = banner;
    const mediaType = { infoSign: InfoSignIcon };
    const bannerType = {
        warning: "hint",
        neutral: "neutral",
        info: "callout"
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Frame, { pb: 4 },
            React.createElement(Banner, { dismissible: dismissible, title: title ? React.createElement(Text, { variant: "strong_1" }, title) : undefined, text: message ? React.createElement(Text, { variant: "body_2" }, message) : undefined, startIcon: media ? React.createElement(Icon, { size: "medium", svg: mediaType[media] }) : undefined, closeAriaLabel: i18n.trans(t("close")), variant: bannerType[type], actions: actionLabel
                    ? [
                        {
                            variant: "primary",
                            text: actionLabel,
                            onClick: showModal
                        }
                    ]
                    : undefined })),
        details && (React.createElement(SheetContainer, { active: showPopover, position: isMobile ? "bottom" : "center", zIndex: 300, title: details.title, onCloseTrigger: () => {
                hideModal();
            }, closeAriaLabel: i18n.trans(t("close")) }, details.message))));
};
export default SearchResultBanner;
